import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useClientAgreementContext } from './ClientAgreementContext';
import OnboardingAlert from '../../Components/OnboardingAlert';

const styles = (theme) => ({
  root: {},
  errorAlert: {
    marginBottom: theme.spacing(2),
  },
});

const ClientAgreementErrorList = ({
  className,
  classes,
}) => {
  const {
    acceptingError,
    billingInformationRefreshError,
  } = useClientAgreementContext();

  const CLIENT_AGREEMENT_ERRORS = [
    {
      visible: acceptingError,
      message: 'There was an issue agreeing to our Client Agreement.',
    },
    {
      visible: billingInformationRefreshError,
      message: 'There was an issue fetching your billing information.',
    },
  ];

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {CLIENT_AGREEMENT_ERRORS.map((error) => {
        return (
          <OnboardingAlert
            key={error.message}
            className={classes.errorAlert}
            visible={error.visible}
            message={error.message}
            error
          />);
      })}
    </Box>
  );
};

ClientAgreementErrorList.defaultProps = {
  className: '',
};

ClientAgreementErrorList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClientAgreementErrorList);
